import React from 'react'
import update from 'immutability-helper';

import { user } from '../../../../core/controllers/user';
import { colorConverter } from '../../../../helpers/General/ColorConverter';
import { spacesColorCoding } from '../../../../core/controllers/SpacesColorCoding';

export default class SpacesColorCode extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            definedColors: null,
            defaultColors: null,
        }
    }

    componentDidMount() {
        spacesColorCoding.getColorCodes(this);
    }

    componentDidUpdate() {
        var input = document.getElementById('vacant');
        var picker = new jscolor(input);

        var input = document.getElementById('occupied');
        var picker = new jscolor(input);

        var input = document.getElementById('maintenance');
        var picker = new jscolor(input);

        var input = document.getElementById('laterent');
        var picker = new jscolor(input);
    }

    componentWillUpdate(nextProps, nextState) {
        // rebind our color listeners
        // TODO: we need to move this to a react component
        jQuery("#vacant").on("change", jQuery.proxy( this.handleVacantColorChange, this ));
        jQuery("#occupied").on("change", jQuery.proxy( this.handleOccupiedColorChange, this ));
        jQuery("#laterent").on("change", jQuery.proxy( this.handleLateRentColorChange, this ));
        jQuery("#maintenance").on("change", jQuery.proxy( this.handleMaintenanceColorChange, this ));

        const definedColors = nextState.definedColors;
        var vacantColor, occupiedColor, lateRentColor, maintenanceColor;
        // lets set the new colors that were specified
        // TODO: maybe create a map to loop throuhg our used colors on the front end
        if(definedColors != null) {
            // these defined colors are hard coded alias values in the db - we need to create a map to better loop and display all optional state colors
            vacantColor = colorConverter.componentToHex(definedColors.vacant.color_code.color_hex_code);
            occupiedColor = colorConverter.componentToHex(definedColors.occupied.color_code.color_hex_code);
            lateRentColor = colorConverter.componentToHex(definedColors.laterent.color_code.color_hex_code);
            maintenanceColor = colorConverter.componentToHex(definedColors.maintenance.color_code.color_hex_code);
        }

        nextState.definedColors.vacant.color_code.color_hex_code = vacantColor;
        nextState.definedColors.occupied.color_code.color_hex_code = occupiedColor;
        nextState.definedColors.laterent.color_code.color_hex_code = lateRentColor;
        nextState.definedColors.maintenance.color_code.color_hex_code = maintenanceColor;
    }

    /* color related handlers for onchange */
    handleVacantColorChange(e) {
        this.setState({
            definedColors: update(this.state.definedColors, {
                vacant: {color_code: {color_hex_code: {$set: e.target.value}}}
            })
        });
    }

    handleOccupiedColorChange(e) {
        this.setState({
            definedColors: update(this.state.definedColors, {
                occupied: {color_code: {color_hex_code: {$set: e.target.value}}}
            })
        });
    }

    handleLateRentColorChange(e) {
        this.setState({
            definedColors: update(this.state.definedColors, {
                laterent: {color_code: {color_hex_code: {$set: e.target.value}}}
            })
        });
    }

    handleMaintenanceColorChange(e) {
        this.setState({
            definedColors: update(this.state.definedColors, {
                maintenance: {color_code: {color_hex_code: {$set: e.target.value}}}
            })
        });
    }

    /* end */

    updateColorCodes() {
        spacesColorCoding.saveColorCodes(this);
    }

    render(){
        // TODO: figure better way to generate user defined colors
        const definedColors = this.state.definedColors;
        const defaultColors = this.state.defaultColors;
        var vacantColor = "FFFFFF", occupiedColor = "FFFFFF", lateRentColor = "FFFFFF", maintenanceColor = "FFFFFF";
        // lets set the new colors that were specified
        // TODO: maybe create a map to loop throuhg our used colors on the front end
        if(definedColors != null) {
            // these defined colors are hard coded alias values in the db - we need to create a map to better loop and display all optional state colors
            vacantColor = definedColors.vacant.color_code.color_hex_code;
            occupiedColor = definedColors.occupied.color_code.color_hex_code;
            lateRentColor = definedColors.laterent.color_code.color_hex_code;
            maintenanceColor = definedColors.maintenance.color_code.color_hex_code;
        }
        return (
            <div class="col-md-8 col-sm-7 col-xs-12">
                <div class="card">
                    <div class="header">
                        <h4 class="title"><i class="pe-7s-edit"></i> <small><i class="pe-7s-angle-right"></i></small> Color Coding</h4>
                        <p class="category">Space(s) Color Codes</p>
                    </div>
                    <div class="content">
                        <div class="row">
                            <div class="col-md-12">
                                <p class="category"><b>General</b></p>
                            </div>
                            <div id="colorSelects">
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label>Vacant Space</label>
                                        <input type="text" class="form-control color-coding jscolor" name="vacant_space" placeholder="" id="vacant" value={vacantColor} onChange={this.handleVacantColorChange.bind(this)}/>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label for="effective_date">Occupied Space</label>
                                        <input type="text" class="form-control color-coding jscolor" name="occupied_space" placeholder="" id="occupied" value={occupiedColor} onChange={this.handleOccupiedColorChange.bind(this)}/>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label for="effective_date">Maintenance</label>
                                        <input type="text" class="form-control color-coding jscolor" name="maintenance" placeholder="" id="maintenance" value={maintenanceColor} onChange={this.handleMaintenanceColorChange.bind(this)}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <p class="category"><b>Tenant(s)</b></p>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label>Late Rent</label>
                                    <input type="text" class="form-control color-coding jscolor" name="late_rent" placeholder="" id="laterent" value={lateRentColor} onChange={this.handleLateRentColorChange.bind(this)}/>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-4 col-md-offset-5 col-sm-4 col-sm-offset-4 col-xs-4 col-xs-offset-4">
                                <button type="button" id="save-color-coding" data-loading-text="Loading..." class="btn btn-secondary btn-info btn-fill" autoComplete="off" onClick={this.updateColorCodes.bind(this)}>
                                    Update
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
};


// WEBPACK FOOTER //
// app/components/Settings/Buildings/Spaces/ColorCode.jsx